var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34651_50060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0C5.37269 0 0 5.37268 0 12.0001C0 18.6278 5.37269 24 11.9999 24C18.6279 24 24 18.6278 24 12.0001C24 5.37311 18.6279 0.000573189 11.9998 0.000573189L11.9999 0ZM17.503 17.3075C17.2881 17.6601 16.8267 17.7718 16.4742 17.5555C13.6567 15.8344 10.1099 15.4447 5.93283 16.399C5.53032 16.4907 5.12909 16.2385 5.03738 15.8359C4.94524 15.4332 5.19644 15.032 5.59996 14.9403C10.1711 13.8955 14.092 14.3456 17.2551 16.2787C17.6076 16.495 17.7194 16.955 17.503 17.3075ZM18.9718 14.0396C18.701 14.4803 18.1249 14.6193 17.685 14.3484C14.4594 12.3653 9.54257 11.7911 5.72735 12.9493C5.23255 13.0987 4.70995 12.8199 4.55978 12.3259C4.41075 11.8311 4.68975 11.3095 5.18369 11.1591C9.54171 9.8367 14.9595 10.4772 18.6637 12.7535C19.1036 13.0244 19.2426 13.6003 18.9718 14.0396ZM19.0979 10.6372C15.2304 8.33995 8.84945 8.12873 5.15689 9.24946C4.56394 9.4293 3.93688 9.09456 3.75719 8.50159C3.5775 7.90834 3.91195 7.28169 4.50533 7.10142C8.74413 5.81461 15.7906 6.06323 20.2434 8.70665C20.7779 9.0232 20.9527 9.71203 20.636 10.2447C20.3208 10.778 19.6301 10.9539 19.0985 10.6372H19.0979Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34651_50060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.86e8ab1f7a4cf019a620a94891414bd0.svg";
export { ForwardRef as ReactComponent };